var __WEBPACK_NAMESPACE_OBJECT__ = dependencies['react-dom']['16']['module'];